var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNavigation = function SvgNavigation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.357 14.217c-.39.171-.585.257-.705.22a.33.33 0 0 1-.217-.218c-.038-.12.047-.314.218-.704L7.508 2.447c.154-.352.231-.528.34-.582a.33.33 0 0 1 .297 0c.108.054.185.23.34.582l4.854 11.068c.17.39.256.585.218.704a.33.33 0 0 1-.217.218c-.12.037-.315-.048-.704-.22L8.21 12.27c-.08-.035-.119-.052-.16-.059a.3.3 0 0 0-.11 0c-.041.007-.08.024-.16.06z"
  })));
};
export default SvgNavigation;